import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { SignUpComponent } from './sign-up/sign-up.component';
import { AuthService } from 'app/auth/auth.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PasswordStengthComponent } from './sign-up/password-stength/password-stength.component';
import { ConfirmSignupComponent } from './sign-up/confirm-signup/confirm-signup.component';
import { ResendCodeComponent } from './resend-code/resend-code.component';
import { SignUpStatusComponent } from './sign-up-status/sign-up-status.component';
import { AuthSignInComponent } from './sign-in/sign-in.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordStatusComponent } from './forgot-password-status/forgot-password-status.component';
import { ResetPasswordStatusComponent } from './reset-password-status/reset-password-status.component';
import { AuthInterceptor } from 'app/auth/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
    declarations: [PasswordStengthComponent, ConfirmSignupComponent],
    imports: [
        AuthRoutingModule,
        // SharedModule,
        MatSnackBarModule,
        SignUpComponent,
        ResendCodeComponent,
        SignUpStatusComponent,
        AuthSignInComponent,
        ResetPasswordComponent,
        ForgotPasswordComponent,
        ForgotPasswordStatusComponent,
        ResetPasswordStatusComponent,
    ],
    providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
})
export class AuthModule {}
